import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../api/client";
import type { User } from "../types";

export function useAuth() {
  const client = useQueryClient();
  const query = useQuery({ queryKey: ["me"], queryFn: () => api<User>("/auth/me"), retry: false });
  const logout = useMutation({ mutationFn: () => api("/auth/logout", { method: "POST" }), onSuccess: () => client.setQueryData(["me"], null) });
  return { user: query.data, isLoading: query.isLoading, logout: logout.mutate };
}

